<template>
  <FormCard v-if="loading === true" class="loading-card">
    <Vue3Lottie :animationData="Loading" :height="300" :width="300"/>
  </FormCard>
  <template v-else>
    <div class="result-banner">
      <v-icon icon="mdi-check-circle" size="20" />
      <div>
        <p class="result-banner__title">계정이 정상적으로 발급되었습니다.</p>
        <p class="result-banner__sub">
          추가 계정 세팅 및 계정 전달을 원하시면 <b>'계정 세팅/전달'</b> 페이지로 이동해주세요.
        </p>
      </div>
    </div>

    <FormCard header="학교 정보" class="section-card">
      <div class="info-table-wrap"><table class="info-table" style="min-width: 700px; width: 100%">
            <tr>
                <td class="table-field">학교 이름</td>
                <td class="table-field">코드</td>
                <td class="table-field">계약시작일</td>
                <td class="table-field">계약만료일</td>
                <td class="table-field">학생 계정수</td>
                <td class="table-field">교사 계정수</td>
                <td class="table-field">LMS 계정수</td>
            </tr>
            <tr>
                <td class="table-data edit__off">{{ school_info.schoolName || '-' }}</td>
                <td class="table-data edit__off">{{ school_info.code || '-' }}</td>
                <td class="table-data">{{ school_info.startDate || '-' }}</td>
                <td class="table-data">{{ school_info.endDate || '-' }}</td>
                <td class="table-data edit__off">{{ school_info.studentCnt || '-' }}</td>
                <td class="table-data edit__off">{{ school_info.teacherCnt || '-' }}</td>
                <td class="table-data edit__off">{{ school_info.lmsCnt || '-' }}</td>
            </tr>
        </table></div>
    </FormCard>

    <FormCard header="학급 정보" class="section-card">
      <div class="info-table-wrap"><table class="info-table" style="min-width: 600px; width: 100%">
            <tr>
                <td class="table-field">학년</td>
                <td class="table-field">반</td>
                <td class="table-field">출판사</td>
                <td class="table-field">학생수</td>
                <td class="table-field">영어 교사</td>
                <td class="table-field">담임 교사</td>
            </tr>
            <tr v-for="(j, i) in class_info" :key="i">
                <td class="table-data">{{ j.grade || '-' }}</td>
                <td class="table-data">{{ j.classNum || '-' }}</td>
                <td class="table-data">{{ j.publisher || '-' }}</td>
                <td class="table-data">{{ j.studentCnt || '-' }}</td>
                <td class="table-data">{{ j.engTeacher || '-' }}</td>
                <td class="table-data">{{ j.teacher || '-' }}</td>
            </tr>
        </table></div>
    </FormCard>

    <FormCard header="교사 LMS 계정" class="section-card">
      <div class="info-table-wrap"><table class="info-table" style="min-width: 700px; width: 100%">
            <tr>
                <td class="table-field">이름</td>
                <td class="table-field">ID</td>
                <td class="table-field">담당학급</td>
            </tr>
            <tr v-for="(j, i) in lms_account" :key="i">
                <td class="table-data">{{ j.name || '-' }}</td>
                <td class="table-data">{{ j.id || '-' }}</td>
                <td class="table-data">
                    <span v-for="(c, k) in j.classList" :key="k">
                        {{ c }}&nbsp;&nbsp;
                    </span>

                </td>
            </tr>
        </table></div>
    </FormCard>

    <FormCard header="교사 알공 계정" class="section-card">
      <div class="info-table-wrap"><table class="info-table" style="min-width: 600px; width: 100%">
            <tr>
                <td class="table-field">학년</td>
                <td class="table-field">반</td>
                <td class="table-field">이름</td>
                <td class="table-field">ID</td>
            </tr>
            <tr v-for="(j, i) in teacher_account" :key="i">
                <td class="table-data">{{ j.grade || '-' }}</td>
                <td class="table-data">{{ j.classNum || '-' }}</td>
                <td class="table-data">{{ j.name || '-' }}</td>
                <td class="table-data"><span class="mono-code">{{ j.id || '-' }}</span></td>
            </tr>
        </table></div>
    </FormCard>

    <FormCard header="학생 알공 계정" class="section-card">
      <div class="info-table-wrap"><table class="info-table" style="min-width: 600px; width: 100%">
            <tr>
                <td class="table-field">학년</td>
                <td class="table-field">반</td>
                <td class="table-field">이름</td>
                <td class="table-field">ID</td>
            </tr>
            <tr v-for="(j, i) in student_account" :key="i">
                <td class="table-data">{{ j.grade || '-' }}</td>
                <td class="table-data">{{ j.classNum || '-' }}</td>
                <td class="table-data">{{ j.name || '-' }}</td>
                <td class="table-data"><span class="mono-code">{{ j.id || '-' }}</span></td>
            </tr>
        </table></div>
    </FormCard>
  </template>
</template>
  
<script setup>
    import { ref, defineProps } from 'vue'
    import { useStore } from 'vuex'
    import { Vue3Lottie } from "vue3-lottie";
    import dayjs from 'dayjs'
    import Loading from "../../../assets/image/loading.json"
    import FormCard from '@/components/ui/FormCard.vue'
    import '../../../assets/style/popupStyle.css'
    import '../../../assets/style/titleStyle.css'
    import '../../../assets/style/wrapStyle.css'
    import '../../../assets/style/buttonStyle.css'
    import '../../../assets/style/inputStyle.css'
    import '../../../assets/style/dropdownStyle.css'

    const store = useStore()

    const props = defineProps(['schoolName', 'schoolCode', 'date'])
    const loading = ref(true)

    console.log('props', props.schoolName, props.schoolCode, props.date)

    const school_info = ref({})
    const class_info = ref({})
    const lms_account = ref([])
    const teacher_account = ref([])
    const student_account = ref([])

    if (props.date.schoolStartDate) {
        setTimeout(async () => {
          const res1 = await store.dispatch("GET_SCHOOL_CLASS_LIST", props.schoolCode)
          console.log('res1 : ', res1)

          class_info.value = {...res1}
          console.log('class_info : ', class_info.value)

          const res2 = await store.dispatch("GET_TYPE_USERS",props.schoolCode)
          console.log('res2 : ', res2)

          lms_account.value={...res2.lmsList}
          teacher_account.value={...res2.teacherList}
          student_account.value={...res2.studentList}

          school_info.value = {
            schoolName: props.schoolName,
            code: props.schoolCode,
            startDate: dayjs(props.date.schoolStartDate).format('YYYY.M.D'),
            endDate: dayjs(props.date.schoolEndDate).format('YYYY.M.D'),
            teacherCnt: res2.teacherList.length,
            studentCnt: res2.studentList.length,
            lmsCnt: res2.lmsList.length
        }

          alert("계정이 생성되었습니다.")
          loading.value = false
        }, 2000)

      } else {
        alert("계정 생성 중 오류가 발생하였습니다.")
        loading.value = false
      }


</script>

<style scoped>
.section-card {
  margin-top: var(--space-6);
}

.loading-card {
  margin-top: var(--space-6);
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
}

.result-banner {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  margin-top: var(--space-6);
  background: var(--color-primary-50);
  border: 1px solid var(--color-primary-300, #7fa8f4);
  border-radius: var(--radius-md);
  color: var(--color-primary-900);
}

.result-banner__title {
  margin: 0 0 var(--space-1);
  font-size: var(--font-body-strong-size);
  font-weight: var(--font-body-strong-weight);
  color: var(--text-primary);
}

.result-banner__sub {
  margin: 0;
  font-size: var(--font-small-size);
  color: var(--text-secondary);
}

.info-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-sm);
}

.info-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--font-body-size);
  line-height: var(--font-body-line);
  color: var(--text-primary);
  background: var(--bg-surface);
  text-align: center;
}

.info-table .table-field {
  padding: var(--space-3) var(--space-4);
  background: var(--bg-subtle);
  color: var(--text-secondary);
  font-size: var(--font-body-strong-size);
  font-weight: var(--font-body-strong-weight);
  border-bottom: 1px solid var(--border-default);
  white-space: nowrap;
}

.info-table .table-data {
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--border-default);
}

.info-table tr:last-child .table-data {
  border-bottom: none;
}

.mono-code {
  font-family: var(--font-family-mono);
  font-size: var(--font-mono-size);
  color: var(--text-primary);
}
</style>